<div class="modalSuccess">
    <div class="headerModal">
      <h4 class="titleModalManager">Gestore modificato con successo</h4>
    </div>
    <div
      class="btnModal"
      style="
        justify-content: center;
        margin-top: 50px;
        text-align: center;
        margin-right: 0px;
      "
    >
      <button class="btnManager" (click)="close()">CHIUDI</button>
    </div>
  </div>